import React from 'react'
import { PageTitleText } from '../../../Auth/reset_password/reset_password.style'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
// import { FieldBtn } from '../../../../widget/SidebarWidget/SidebarWidget.style'
import { GuestListTableContainer} from './dues.style'
import DuesSearchByResidentOrAddress from './widgets/searchByResidentOrAddress'
// import DuesSearchByFilter from './widgets/searchByFilter'


function DuesSpecificPageWidget() {
const history = useHistory()
  return (
    <div className=''>
        <PageTitleText onClick={()=>history.push("/dues")}
            style={{
                fontSize:"20px !important"
            }}
        >
            <button className='btn btn-flat transparent'>
                <i className='material-icons'>arrow_back</i>
            </button>
            Dues for Specific Properties
        </PageTitleText>


        <GuestListTableContainer>
            <div className='row'>
            <div className='col s12 '>
                <h6 style={{
                        fontSize:"16px ",
                        fontWeight:"600px !important"
                    }}>Search or Filter to Select Specific Properties
                </h6>
            </div>
            <br/>
            <br/>
            <br/>
            <div className='col s12 ' >
                <h6 style={{
                    fontSize:"12px "
                }}><b style={{
                    fontSize:"14px "
                }}> Search </b>  -  Recommended for selecting 5 to 10 properties</h6>
                <DuesSearchByResidentOrAddress />
            </div>
            {/* <div className='col s12 mt-50'>
                <h6 style={{
                    fontSize:"12px "
                }}><b style={{
                    fontSize:"14px "
                }}>Filter</b>  -  Recommended for selecting more than 10 properties</h6>
                <DuesSearchByFilter/>
            </div> */}
            <br/>
            {/* <br/>
                <div className='col s12 mt-25'>
                    <FieldBtn onClick={()=>console.log("d")} class="waves-effect waves-light btn-flat ">
                        Proceed
                    </FieldBtn>
                </div> */}
            </div>
        </GuestListTableContainer>
    </div>
  )
}

export default DuesSpecificPageWidget










